import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
  const jwt = localStorage.getItem('jwt');
  return jwt ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute; 